
import MetricData from "src/shared/models/metric-data";
import { MetricDefinition } from "src/shared/models/pipeline-config/metric-definition.models";

export interface MyRankingCollection {
    error: ErrorList;
    profile: MyRankingProfile;
    data: MyRankingData[];
}

export interface MyRankingProfile {
    name: string;
    group: string;
    imageSource: string;
}
export interface MyRankingData {
    rank: number;
    totalGroups: number;
    metricName: string;
    metricDisplayValue: string;
    ranking: Ranking;
}

export enum Ranking {
    High = 0,
    Medium = 1,
    Low = 2,
    NoRank = 3,
}

export enum ErrorList {
    NoError = 0,
    NoMetric = 1,
    DateRangeTooWideIntraday = 2,
    GroupLevelTooHigh = 3,
    NoSingleGroupSelected = 4,
}
